/**
 * Set of codes used for `Coverage.class.type`
 */
export enum CoverageClassCode {
  /**
   * An employee group.
   */
  Group = 'group',
  /**
   * A sub-group of an employee group.
   */
  SubGroup = 'subgroup',
  /**
   * A specific suite of benefits.
   */
  Plan = 'plan',
  /**
   * A subset of a specific suite of benefits.
   */
  SubPlan = 'subplan',
  /**
   * A class of benefits.
   */
  Class = 'class',
  /**
   * A subset of a class of benefits.
   */
  SubClass = 'subclass',
  /**
   * A sequence number associated with a short-term continuance of the coverage.
   */
  Sequence = 'sequence',
  /**
   * Pharmacy benefit manager's Business Identification Number.
   */
  PharmacyBusinessIdentificationNumber = 'rxbin',
  /**
   * A Pharmacy Benefit Manager specified Processor Control Number.
   */
  PharmacyProcessControlNumber = 'rxpcn',
  /**
   * A Pharmacy Benefit Manager specified Member ID.
   */
  PharmacyMemberId = 'rxid',
  /**
   * A Pharmacy Benefit Manager specified Group number.
   */
  PharmacyGroupNumber = 'rxgroup',
}

export const CoverageClassDisplayMapping: Record<CoverageClassCode, string> = {
  [CoverageClassCode.Group]: 'Group',
  [CoverageClassCode.SubGroup]: 'SubGroup',
  [CoverageClassCode.Plan]: 'Plan',
  [CoverageClassCode.SubPlan]: 'SubPlan',
  [CoverageClassCode.Class]: 'Class',
  [CoverageClassCode.SubClass]: 'SubClass',
  [CoverageClassCode.Sequence]: 'Sequence',
  [CoverageClassCode.PharmacyBusinessIdentificationNumber]:
    'Pharmacy Business Identification Number',
  [CoverageClassCode.PharmacyProcessControlNumber]:
    'Pharmacy Process Control Number',
  [CoverageClassCode.PharmacyMemberId]: 'Pharmacy Member ID',
  [CoverageClassCode.PharmacyGroupNumber]: 'Pharmacy Group Number',
};
